import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=6b7dce2b&scoped=true"
import script from "./RoleSelection.vue?vue&type=script&lang=js"
export * from "./RoleSelection.vue?vue&type=script&lang=js"
import style0 from "./RoleSelection.vue?vue&type=style&index=0&id=6b7dce2b&prod&scoped=true&lang=scss"
import style1 from "./RoleSelection.vue?vue&type=style&index=1&id=6b7dce2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7dce2b",
  null
  
)

export default component.exports